export default "__VITE_ASSET__CeElVObQ__"